import React, { useState } from "react";
import styled from "styled-components";
import {
  FirstDoubleArrow,
  LastDoubleArrow,
  NextSingle,
  PrevSingle,
} from "../styled/AllImages";
import { useTranslation } from "react-i18next";
import { useUser } from "../../context/userContext";

const PaginationWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 6px;
  justify-content: flex-end;
  align-items: center;
  max-width: 100%;
  margin: 50px auto 20px auto;

  @media (max-width: 767px) {
    justify-content: center;
    gap: 0;
  }

  @media (max-width: 364px) {
    justify-content: center;
    gap: 2px;
  }
`;

const PageButton = styled.button`
  padding: 6px 12px;
  min-width: 36px;
  border: none;
  border-radius: 12px;
  background-color: ${({ active }) =>
    active ? "var(--themeColorSecondary)" : "var(--bg)"};
  color: ${({ active }) => (active ? "#fff" : "var(--themeColorSecondary)")};
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: ${({ active }) => (active ? "var(--themeColorSecondary)" : "#ddd")};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 364px) {
    padding: 4px 8px;
    font-size: 12px;
    min-width: 28px;
    border-radius: 8px;
  }
`;

const Ellipsis = styled.span`
  padding: 6px 12px;
  color: #888;

  @media (max-width: 364px) {
    padding: 4px 8px;
    font-size: 12px;
  }
`;

const FixedIconWrapper = styled.span``;

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const {i18n} = useTranslation();
  const generatePageNumbers = () => {
    const delta = 2;
    const pages = [];

    for (
      let i = Math.max(2, currentPage - delta);
      i <= Math.min(totalPages - 1, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }

    if (currentPage - delta > 2) pages.unshift("...");
    if (currentPage + delta < totalPages - 1) pages.push("...");

    pages.unshift(1);
    if (totalPages > 1) pages.push(totalPages);

    return pages;
  };

  return (
    <PaginationWrapper>
      <PageButton onClick={() => onPageChange(1)} disabled={currentPage === 1}>
        <FixedIconWrapper style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}>
          <FirstDoubleArrow style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}/>
        </FixedIconWrapper>
      </PageButton>
      <PageButton
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <FixedIconWrapper style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}>
          <PrevSingle style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}} />
        </FixedIconWrapper>
      </PageButton>

      {generatePageNumbers().map((page, idx) =>
        page === "..." ? (
          <Ellipsis key={idx}>...</Ellipsis>
        ) : (
          <PageButton
            key={idx}
            active={currentPage === page}
            onClick={() => onPageChange(page)}
          >
            {page.toLocaleString("en-US")}
          </PageButton>
        )
      )}

      <PageButton
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <FixedIconWrapper style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}>
          <NextSingle style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}} />
        </FixedIconWrapper>
      </PageButton>
      <PageButton
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        <FixedIconWrapper style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}>
          <LastDoubleArrow style={{transform:	i18n.language === "ar" ? "scaleX(-1)" : "scaleX(1)"}}/>
        </FixedIconWrapper>
      </PageButton>
    </PaginationWrapper>
  );
};


const PaginatedList = () => {
  const { currentPage, setCurrentPage, totalPages } = useUser();



  return (
    <>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </>
  );
};

export default PaginatedList;
